import BaseBusinessAPI from '@/apis/portal/baseBusinessAPI'

class AccountAPI extends BaseBusinessAPI {
  controllerName = 'Authenticates';
}

export default new AccountAPI()
